<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ model?.id ? 'Rediger model' : 'Opret model' }}</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Fabrikat</mat-label>
        <mat-select formControlName="fabrikat">
          @for (fabrikat of fabrikater; track fabrikat) {
            <mat-option [value]="fabrikat.id">{{ fabrikat.name }} - {{ fabrikat.produkt.text }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix class="select-arrow">keyboard_arrow_down</mat-icon>
      </mat-form-field>
    </div>

    @if (model) {
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Navn</mat-label>
          <input formControlName="name" matInput />
        </mat-form-field>
      </div>
    }

    @if (!model) {
      <div class="form-row">
        <mat-form-field appearance="outline" class="mdc-textarea-fix">
          <mat-label>Navne</mat-label>
          <textarea formControlName="names" rows="5" matInput placeholder="Indtast en eller flere modeller"></textarea>
        </mat-form-field>
      </div>
    }

    <div class="form-row no-margin-bottom">
      <mat-form-field appearance="outline">
        <mat-label>Tillad oprettelse</mat-label>
        <mat-select formControlName="modelstatus">
          @for (status of modelstatusser; track status) {
            <mat-option [value]="status.value">{{ status.name }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix class="select-arrow">keyboard_arrow_down</mat-icon>
      </mat-form-field>
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close="">Fortryd</button>
  <button [disabled]="!form.valid" mat-raised-button color="primary" (click)="update()">Gem</button>
</div>
